import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Package, Loader2 } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

const LoginPage = () => {
  const [accessCode, setAccessCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accessCode.trim()) {
      toast.error('Please enter your access code');
      return;
    }

    setLoading(true);
    try {
      await login(accessCode);
      toast.success('Welcome to StockOps!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid access code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-sm animate-enter">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mb-4 shadow-lg">
            <Package className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-heading font-bold text-foreground">StockOps</h1>
          <p className="text-sm text-muted-foreground mt-1">Backroom Stock Logger</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
          <div>
            <label htmlFor="accessCode" className="sr-only">Access Code</label>
            <Input
              id="accessCode"
              type="password"
              placeholder="Enter access code"
              value={accessCode}
              onChange={(e) => setAccessCode(e.target.value)}
              className="input-large text-center tracking-widest font-bold text-foreground placeholder:text-muted-foreground/40"
              autoComplete="off"
              autoFocus
              data-testid="access-code-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="btn-primary-action"
            data-testid="login-submit"
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                <span>Signing in...</span>
              </>
            ) : (
              <span>Sign In</span>
            )}
          </Button>
        </form>

        {/* Help text */}
        <p className="text-center text-xs text-muted-foreground mt-6">
          Contact your admin if you need access
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
